import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import runtimeEnv from "@mars/heroku-js-runtime-env";
import axios from "axios";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { Formik } from "formik";
import ResponsiveMobileStepper from "./ResponsiveMobileStepper";
import NextBackButtons from "./NextBackButtons";
import * as yup from "yup";
import Grid from "@material-ui/core/Grid";
import Box from "./Box";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = (theme) => ({
  root: {
    textAlign: "center",
  },
  introText: {
    fontSize: 32,
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(4),
    },
  },
  boxNote: {
    paddingBottom: theme.spacing(4),
  },
});

class Boxes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      boxes: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });

    return axios
      .get(runtimeEnv().REACT_APP_API_URL + "/boxes")
      .then((response) => {
        this.setState(
          {
            boxes: response.data,
            loading: false,
          },
          () => this.props.updateBoxes(response.data)
        );
      })
      .catch((error) => {
        console.log(error); //eslint-disable-line no-console
        console.log(error.response); //eslint-disable-line no-console

        this.setState({
          loading: false,
        });
      });
  }

  sumValues = (obj) => {
    //Based on https://stackoverflow.com/questions/16449295/how-to-sum-the-values-of-a-javascript-object
    return Object.keys(obj).reduce((sum, key) => {
      let quantity = parseFloat(obj[key] || 0);
      let box = this.state.boxes.find((box) => "box" + box.id === key); //based on how we generate names in Box.js
      return sum + box.price * quantity;
    }, 0);
  };

  render() {
    const { classes } = this.props;

    const boxes = this.state.boxes;

    return (
      (this.state.loading && (
        <div style={{ margin: "40px auto 40px auto", textAlign: "center" }}>
          <CircularProgress />
        </div>
      )) || (
        <Formik
          validateOnChange={true}
          validationSchema={yup.object(
            boxes.length &&
              boxes.reduce((sum, box) => {
                //create an object that is a yup setting for each box
                return {
                  ...sum,
                  ["box" + box.id]: yup.number().label("Quantity"),
                };
              }, {})
          )}
          initialValues={
            (!(
              Object.entries(this.props.values).length === 0 &&
              this.props.values.constructor === Object
            ) &&
              this.props.values) || //If there are already values, use those - make sure it's not just an empty object though, see https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
            (boxes.length &&
              boxes.reduce((sum, box) => {
                //create an object that is just an empty string for each box
                return { ...sum, ["box" + box.id]: "" };
              }, {}))
          }
          onSubmit={(values, actions) => {
            window.dataLayer.push({
              event: "select-box-kits",
              eventProps: {
                category: "Ecommerce",
                action: "Click",
                label: "Page 6 - Select Box Kits",
              },
            });

            actions.setSubmitting(false);
            this.props.handleNext(values);
          }}
          render={({
            values,
            errors,
            // eslint-disable-next-line no-unused-vars
            status,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            // eslint-disable-next-line no-unused-vars
            setFieldValue,
            // eslint-disable-next-line no-unused-vars
            setFieldError,
            isSubmitting,
          }) => (
            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid
                container
                spacing={4}
                justify="center"
                className={classes.root}
              >
                <Grid container justify="center" item xs={12}>
                  <Grid item xs={12} sm={8} md={6}>
                    <Typography className={classes.introText}>
                      We ship boxes directly to your door because that is what
                      moving buddies do.
                    </Typography>
                  </Grid>
                </Grid>

                {(boxes.length &&
                  boxes.map((box) => (
                    <Grid
                      container
                      justify="center"
                      item
                      xs={12}
                      key={box.id.toString()}
                    >
                      <Grid item xs={12} sm={8} md={6} lg={4}>
                        <Box
                          box={box}
                          values={values}
                          errors={errors}
                          touched={touched}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          isSubmitting={isSubmitting}
                        />
                      </Grid>
                    </Grid>
                  ))) || <p className={classes.helperText}>No boxes yet.</p>}
                <Grid container justify="center" item xs={12}>
                  <Grid item xs={12} sm={8} md={4}>
                    <Typography
                      className={classes.boxNote}
                      color="textSecondary"
                    >
                      Boxes will be shipped within <strong>5 days</strong> from
                      the date ordered. They will be shipped to your home.
                    </Typography>
                  </Grid>
                </Grid>
                <NextBackButtons
                  backOnClick={this.props.handleBack}
                  nextOnClick={this.handleBoxesModalOpen}
                  disableBoth={isSubmitting}
                  nextLabel="Confirm Reservation"
                />
                <ResponsiveMobileStepper
                  steps={this.props.steps}
                  backOnClick={this.props.handleBack}
                  activeStep={this.props.activeStep}
                  nextLabel="Confirm Reservation"
                />
              </Grid>
            </form>
          )}
        />
      )
    );
  }
}

Boxes.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  values: PropTypes.object.isRequired,
  updateBoxes: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
};

export default withStyles(styles)(Boxes);
